import ky from 'ky';

export const fetchRemoteAsset = async (url, onProgress) => {


	// pgw 05-nov-2025
	console.log(' fetchRemoteAsset url = ', url);
    const progressHandler = (progress) => {
        // const progressPercentage = ((progress.loaded/progress.total) * 100).toFixed(0);
        onProgress(progress.percent * 100);
    }

	// pgw 20-apr-2023
	// Set timeout to 60 seconds (rather than default, which is 10 seconds)

	// pgw 20-may-2025 testing
	// add x-auth-token to call
    const response = {
        data: await ky.get(url, {
      		headers: { 'x-auth-token': 'bb54306d0562eb67d9308c61b5b146dad4c34e5592c367dce93bf7b8fcc7457d' },
            onDownloadProgress: progressHandler,
			timeout: 60000
        }).arrayBuffer()
    }
    return response;
}